import React from "react";
import {autorun} from "mobx";

import {UiState} from "../../../ui-state";

import {PopupConfiguration} from "../../../config/popup-configuration";
import {observer} from "mobx-react";
import {MapViewerConfiguration} from "../../../../config/map-viewer-configuration";
import {Accordion, Pagination, PaginationProps} from "semantic-ui-react";

import {PopupPanelItem} from "./popup-panel-item/popup-panel-item";
import {Icon} from "../../icon/icon";
import {AppConfiguration} from "../../../config/app-configuration";

interface PopupPanelProps {
    appConfig: AppConfiguration;
    config: PopupConfiguration;
    mapViewerConfig: MapViewerConfiguration;
    view: __esri.MapView | __esri.SceneView | undefined;
    graphics: __esri.Graphic[];
    title: string;
    popup: any;
    uiStore: UiState;
    index: number;
}
@observer
export class PopupPanel extends React.Component<PopupPanelProps, any> {
    watchHandles: any[] = [];
    popup: any;
    index: number;
    constructor(props: PopupPanelProps) {
        super(props);
        this.state = {
            viewModel: null,
            items: [],
            activePage: 1,
            isLoading: true
        };
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
    }
    handlePaginationChange(e: React.MouseEvent, pagination: PaginationProps): void {
        const { activePage } = pagination;
        const { index, popup } = this.props;
        this.setState({ activePage });
        const activePages = popup.state.activePages;
        activePages[index] = activePage;
        popup.setState({activePages, selectedPanelIndex: index});
        popup.highlight(index, activePage);
    }
    componentDidMount(): void {
        const {graphics, view, popup, index} = this.props;
        // Feldtypen welche im NULL Fall mit "-" ersetzt werden
        autorun((reaction: any) => {
            if (!view) {
                return;
            }
            if (!popup) {
                return;
            }
            const items: any[] = [];
            let featureIndex = 1;
            const activePages = popup.state.activePages;
            activePages[index] = 1;
            popup.setState({activePages});
            graphics.forEach((graphic) => {
                // sourceLayer on Graphic is not documented!
                const sourceLayer = (graphic as any).sourceLayer;
                popup.prepareDefaultFormat(sourceLayer);
                const valueUnitMap = popup.valueUnitMap.get(sourceLayer.uid as string);
                const fieldMap = popup.defaultFormatMap.get(sourceLayer.uid as string);
                fieldMap.forEach((fieldFormat, k: string )=> {
                    if (graphic.attributes.hasOwnProperty(k)) {
                        // Alle NULL Werte mit "-" überschreiben
                        if (graphic.attributes[k] === null) {
                            const fieldType = sourceLayer.getField(k)?.type;
                            if (popup.nullableFieldType.indexOf(fieldType) > -1) {
                                graphic.attributes[k] = "-";
                            }
                        } else {
                            // Numerische Werte selber formatieren
                            const fieldType = sourceLayer.getField(k)?.type;
                            if(!isNaN(graphic.attributes[k]) && popup.numericFieldType.indexOf(fieldType) > -1) {
                                const o: any = {};
                                if(fieldFormat){
                                    if("places" in fieldFormat){
                                        o.maximumFractionDigits = fieldFormat.places;
                                    }
                                    if("digitSeparator" in fieldFormat){
                                        o.useGrouping  = fieldFormat.digitSeparator;
                                    }
                                }
                                graphic.attributes[k] =
                                    new Intl.NumberFormat("de-CH", o).format(graphic.attributes[k]);
                            }
                        }
                        // Attribute auf Masseinheit in valueUnitMap überprüfen
                        if (valueUnitMap) {
                            const unit = valueUnitMap.get(k);
                            if (typeof unit === "string" && graphic.attributes[k] !== null) {
                                graphic.attributes[k] += " " + unit;
                            }
                        }
                    }
                });
                items.push(<PopupPanelItem
                    appConfig={this.props.appConfig}
                    config={popup.props.config}
                    graphic={graphic}
                    popup={popup}
                    mapViewerConfig={popup.props.mapViewerConfig}
                    view={popup.props.view}
                    uiStore={popup.props.uiStore}
                    panel={this}
                    index={featureIndex}
                    key={featureIndex}/>
                );
                featureIndex++;
            });
            this.setState({items});
            /* const featureChild = new EsriFeature({
                graphic: graphic,
                map: view.map,
                spatialReference: view.spatialReference,
                visibleElements: { title: false }
            });*/
            /* featureChild.watch("title", (title) => {
                this.setState({title: title});
            });*/
            reaction.dispose();
        });
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    render(): JSX.Element | null {
        const { items } = this.state;
        const {popup, index, title} = this.props;
        if (!popup) {
            return null;
        }
        this.index = index;
        let contentClass = "geo-panel";
        if (popup.state.selectedPanelIndex === index) {
            contentClass+= " geo-panel-selected";
        }
        return (
            <div><Accordion.Title
                index={index}
                active={popup.state.activeIndex.includes(index)}
                onClick={popup.handleClick}
            >
                <Icon name="navigate_plus" />
                <Icon name="navigate_minus" />
                {title}
            </Accordion.Title>
            <Accordion.Content className={contentClass} active={popup.state.activeIndex.includes(index)}
                data-index={index}>
                { items.length > 1 && <Pagination
                    defaultActivePage={1}
                    firstItem={null}
                    lastItem={null}
                    size="small"
                    pointing
                    secondary
                    totalPages={items.length}
                    onPageChange={this.handlePaginationChange}
                />}
                {items}
            </Accordion.Content></div>
        );
    }
}
